

import { Component, OnInit } from '@angular/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


// export interface FoodNode {
//   name: string;
//   children?: FoodNode[];
// }

// export interface Food {
//   value: string;
//   viewValue: string;
// }

// const TREE_DATA: FoodNode[] = [

//    {
//   name: 'User Management',
//   children: [
//     {
//       name: 'Create User',
//       children: [
//         {name: 'New User'},
//         {name: 'Create Patient'},
//         {name: 'Edit Patient'},
//       ]
//     }, {
//       name: 'Menu',
//       children: [
//         {name: 'Home'},
//         {name: 'Schedule'},
//         {name: 'Patient Chart'},

//       ]
//     },
//   ]
// },

// ];


// const TREE_DATA1: FoodNode[] = [

//   {
//  name: 'User Management1',
//  children: [
//    {
//      name: 'Create User',
//      children: [
//        {name: 'New User'},
//        {name: 'Create Patient'},
//        {name: 'Edit Patient'},
//      ]
//    }, {
//      name: 'Menu',
//      children: [
//        {name: 'Home'},
//        {name: 'Schedule'},
//        {name: 'Patient Chart'},

//      ]
//    },
//  ]
// },

// ];

// export interface PeriodicElement {
//   Select: string;
//   description: string;
//   datasource1: FoodNode[];

// }

// const ELEMENT_DATA: PeriodicElement[] = [
//   { Select: '', description: '', datasource1: TREE_DATA},
//   { Select: '', description: '', datasource1: TREE_DATA1},
// ];

// export interface PeriodicElement1 {
//   isSelect: string;
//   isActive: string;
//   roles: string;
// }

// const ELEMENT_DATA1: PeriodicElement1[] = [
//   { isSelect: '', isActive: 'True',roles: 'Provider'},
//   { isSelect: '', isActive: 'True',roles: 'Admin'},
//   { isSelect: '', isActive: 'False',roles: 'Clerk'},
//   { isSelect: '', isActive: 'True',roles: 'Provider'},
//   { isSelect: '', isActive: 'True',roles: 'Provider'},

// ];

@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html',
  styleUrls: ['./permission.component.css']
})

export class PermissionComponent implements OnInit {

  // displayedColumns: string[] = ['Select', 'description'];

  // dataSource = ELEMENT_DATA;


  // displayedColumnss: string[] = ['isSelect', 'isActive','roles'];

  // dataSource3 = ELEMENT_DATA1;

  // treeControl = new NestedTreeControl<FoodNode>(node => node.children);

  // treeControls = new NestedTreeControl<FoodNode>(node => node.children);

  // datasource1 = new MatTreeNestedDataSource<FoodNode>();

  // datasource2 = new MatTreeNestedDataSource<FoodNode>();

  // foods: Food[] = [
  //   { value: 'steak-0', viewValue: 'Steak' },
  //   { value: 'pizza-1', viewValue: 'Pizza' },
  //   { value: 'tacos-2', viewValue: 'Tacos' }
  // ];

  constructor(private formBuilder: FormBuilder) {

  }

  permissionForm: FormGroup;
  submitted = false;

  //hasChild = (_: number, node: FoodNode) => !!node.children && node.children.length > 0;

  ngOnInit() {
    this.permissionForm = this.formBuilder.group({
      rolenam: [''],
    });
  }

}

